import { computed, get } from "@ember/object"
import { flatMap, map, values } from "lodash-es"

/**
 * A macro that returns a computed property that returns an array of proxy objects
 * that resolve to prismic-doc ids
 * @param  {String}  modelName -path to the prismicDoc `e.g. `prismicDoc` or `prismicSlice`
 * @return {Array<String>} - An array of ids to reference the prismic-doc
 */

export default function extractPrismicItemIds(modelName: string) {
  /**
   * Example:

    ``` javascript
      class exampleComponent extends Component {
        prismicSlice = { items: [
                                  { "slice_type": {id: 3} },
                                  { "slice_type": {id: 6} },
                                  { "slice_type": {id: 4} }
                                ]
                        }
        @extractPrismicItemIds("prismicSlice") prismicIds
      }
    ```
   */
  return computed(`${modelName}.items.[]`, function (): Array<string> | null {
    return flatMap(get(this[modelName], "items"), (item) => {
      return map(values(item), (obj) => get(obj, "id"))
    })
  })
}
